// import Payroll from './Payroll';

export default {
  // component: Payroll,
  component: load(() => import(/* webpackChunkName: "Payroll" */ "./Payroll")),
  priority: 700,
  // permissions: ["Payroll", "isNotAdmin", "PayrollNew"],
  permissions: [
    "Payroll",
    "PayrollPrinting",
  ],
  name: app.translate("routes.home.payroll.Payroll"),
  icon: "cloud-print-outline",
  drawer: true,
  path: "payroll",
  description: `فیش حقوقی: امکان مشاهده فایل PDF فیش حقوقی در این منو وجود دارد. پس از انجام محاسبات حقوق و ایجاد آنها در قالب مشخصی که به نام گذاری فایل‌ها مربوط می شود و قراردادن آنها در محل مورد نظر در سرور نرم افزار،‌ هر پرسنل می تواند به فایل فیش حقوقی ماه و سال مورد نظر خود دسترسی داشته باشد. 
این موضوع می تواند مراجعات به واحد مالی را کاهش داده، همچنین از هزینه های مربوط به چاپ فیش حقوقی نیز بکاهد.`,
};
